import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const ImportIcon = withSvgIcon(
    <g>
        <path d="M355.2 330.6V420c0 22.6-18.4 41-41 41H80c-22.6 0-41-18.4-41-41V185.8c0-22.6 18.4-41 41-41h88.4c-.2-3.9-.3-7.8-.3-11.7 0-2.1.2-4.2.4-6.2-.2-7-.1-14 .2-21.1H80c-44.1 0-80 35.9-80 80V420c0 44.1 35.9 80 80 80h234.2c44.1 0 80-35.9 80-80v-89.6c-13 .1-26 .2-39 .2z" />
        <path d="M208.5 106.5l-6.8 191.8 191.8-6.8-59.3-59.2L500 66.5 433.5 0 267.7 165.8z" />
    </g>
);
